// Single source of truth for Cluster M query keys (v0.5.0).
// Pattern matches DAILY_KEY/TIER_KEY in useAgentMetrics.ts.

export const PROFILE_SUMMARY_KEY = ['agents', 'me', 'profile-summary'] as const;

export const HISTORY_KEY = (months: number) =>
  ['agents', 'me', 'history', months] as const;

export const ADMIN_AGENT_PROFILE_KEY = (agentId: number) =>
  ['admin', 'agents', agentId, 'profile-summary'] as const;

export const ADMIN_AGENTS_PROGRESS_OVERVIEW_KEY =
  ['admin', 'agents-progress-overview'] as const;
